import { Immutable } from "immer";
import React from "react";

import type { ProductHeroBanner as Value } from "@reactivated";

import { originalUrl } from "../../utils/wagtail";

type IProps = Immutable<{
    value: Value;
}>;

/**
 * Faithful JSX transcription of the legacy sealy
 * ``components/hero_banners/product_hero_banner.html`` (#33285).
 */
export const ProductHeroBanner = (props: IProps): React.JSX.Element => {
    const value = props.value;
    return (
        <section
            className="panel panel--offset"
            style={{
                backgroundImage: `url('${originalUrl(value.image)}')`,
            }}
        >
            <div className="panel__content">
                {value.title && <h2 className="panel__line">{value.title}</h2>}
                <h1 className="panel__title">{value.subtitle}</h1>
                <p className="panel__copy alt-copy">{value.description}</p>
            </div>
        </section>
    );
};
